import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthProvider } from "./auth/AuthProvider";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { Sidebar } from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import TaskDetail from "./pages/TaskDetail";
import Login from "./pages/Login";
import Settings from "./pages/Settings";

// Lazy-loaded admin page (code splitting / route detection)
const Admin = lazy(() => import("./pages/Admin"));

function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen bg-dark-950 text-dark-50">
      <Sidebar />
      {children}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout><Dashboard /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/task/:id"
            element={
              <ProtectedRoute>
                <AppLayout><TaskDetail /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <AppLayout><Settings /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <AppLayout>
                  <Suspense fallback={<div className="flex-1 flex items-center justify-center text-dark-400">Loading...</div>}>
                    <Admin />
                  </Suspense>
                </AppLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
